module.exports = __webpack_public_path__ + "static/media/car.a5a085b0.png";